import { createAction } from '@reduxjs/toolkit'
import reducer from './reducer'

export const { startSaving, finishSaving } = reducer.actions

export const markExtensionPassedReview = createAction(
  'extensionVersions/markExtensionPassedReview'
)
